import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '商品列表',}
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品',}
      },
      {
        path: 'copyProduct',
        name: 'copyProduct',
        component: () => import('@/views/pms/product/copy'),
        meta: {title: '复制商品'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类',}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表',}
      },
      {
        path: 'otherOrder',
        name: 'otherOrder',
        component: () => import('@/views/oms/order/otherOrder'),
        meta: {title: '逾期订单',}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '商品快照'},
        hidden:true
      },
      {
        path: 'userinfo',
        name: 'userinfo',
        component: () => import('@/views/oms/credit/userinfo'),
        meta: {title: '用户征信',},
        hidden:true
      },
      {
        path: 'userReport',
        name: 'userReport',
        component: () => import('@/views/oms/credit/userReport'),
        meta: {title: '用户征信',},
        hidden:true
      },
    ]
  },
  {
    path: '/kcxt',
    component: Layout,
    redirect: '/kcxt/supplier',
    name: 'kcxt',
    meta: {title: '库存系统', icon: 'inventory'},
    children: [
      {
        path: 'supplier',
        name: 'supplier',
        component: () => import('@/views/kcxt/supplier/index'),
        meta: {title: '供应商列表',}
      },
      {
        path: 'goods',
        name: 'goods',
        component: () => import('@/views/kcxt/goods/index'),
        meta: {title: '商品列表',}
      },
      {
        path: 'inventories',
        name: 'inventories',
        component: () => import('@/views/kcxt/inventories/index'),
        meta: {title: '商品库存列表',}
      }
    ]
  },
  {
    path: '/cwxt',
    component: Layout,
    redirect: '/cwxt/finance',
    name: 'cwxt',
    meta: {title: '财务系统', icon: 'finance'},
    children: [
      {
        path: 'finance',
        name: 'finance',
        component: () => import('@/views/cwxt/finance/index'),
        meta: {title: '订单明细',}
      },
      {
        path: 'orderFeeDetails',
        name: 'orderFeeDetails',
        component: () => import('@/views/cwxt/finance/orderFeeDetails'),
        meta: {title: '订单费用明细',},
      },
      {
        path: 'shopFinance',
        name: 'shopFinance',
        component: () => import('@/views/cwxt/finance/shopFinance'),
        meta: {title: '店铺资金明细',},
      }
    ]
  },
  {
    path: '/tslb',
    component: Layout,
    redirect: '/tslb/complaint',
    name: 'tslb',
    meta: {title: '投诉', icon: 'ums-menu'},
    children: [
      {
        path: 'complaint',
        name: 'complaint',
        component: () => import('@/views/tslb/complaint/index'),
        meta: {title: '投诉列表',}
      },
      {
        path: 'detailPage',
        name: 'detailPage',
        component: () => import('@/views/tslb/complaint/detailPage'),
        meta: {title: '投诉详情'},
        hidden:true
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('@/views/tslb/complaint/feedback'),
        meta: {title: '投诉反馈'},
        hidden:true
      },
    ]
  },
  {
    path: '/yhlb',
    component: Layout,
    redirect: '/yhlb/userlist',
    name: 'yhlb',
    meta: {title: '用户', icon: 'ums-admin'},
    children: [
      {
        path: 'userlist',
        name: 'userlist',
        component: () => import('@/views/yhlb/userlist/index'),
        meta: {title: '用户列表',}
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/yhlb/userlist/admin'),
        meta: {title: '管理员列表',}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/yhlb/userlist/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'addUser',
        name: 'addUser',
        component: () => import('@/views/yhlb/userlist/addUser'),
        meta: {title: '添加/编辑用户'},
        hidden: true
      },
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms-coupon'},
    children: [
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '活动列表',}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加活动'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改活动'},
        hidden:true
      },
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表',}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '设置选项',}
      },
      {
        path: 'contract',
        name: 'contract',
        component: () => import('@/views/ums/resource/contractList'),
        meta: {title: '合同列表',}
      },
      {
        path: 'contractDetail',
        name: 'contractDetail',
        component: () => import('@/views/ums/resource/contractDetail'),
        meta: {title: '合同详情',},
        hidden: true
      },
    ]
  },
  {
    path:'/bms',
    component:Layout,
    redirect:'/bms/storeList',
    name:'bms',
    meta:{title:'店铺',icon:'shop'},
    children:[
      {
        path:'storeList',
        name:'storeList',
        component: () => import('@/views/bms/storeList'),
        meta:{title:'店铺列表',}
      },
      {
        path:'addStore',
        name:'addStore',
        component: () => import('@/views/bms/addStore'),
        meta:{title:'添加店铺',},
        hidden: true
      },
      {
        path:'storeDetail',
        name:'storeDetail',
        component: () => import('@/views/bms/storeDetail'),
        meta:{title:'编辑店铺',},
        hidden: true
      }
    ]
  },
  
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js